import { CHANNEL } from '../../constants/messageTemplateKeys';
import { resolveTabKey } from './resolveTabKey';

function channelsForTabKey(tabKey) {
  return tabKey === 'text' ? [CHANNEL.SMS, CHANNEL.MMS] : [CHANNEL.EMAIL];
}

export function resolveChannelsForTab({ tabKey, selected }) {
  const resolvedTabKey = resolveTabKey(tabKey);

  if (resolvedTabKey === CHANNEL.EMAIL) return [CHANNEL.EMAIL];

  const allowed = new Set([CHANNEL.SMS, CHANNEL.MMS]);
  const normalizedSelected = Array.isArray(selected)
    ? selected.map((v) => String(v).trim().toLowerCase())
    : [];
  const sanitized = normalizedSelected.filter((v) => allowed.has(v));
  return sanitized.length > 0 ? sanitized : channelsForTabKey(resolvedTabKey);
}
